import { useSubscription } from "@apollo/client";
import { ContentStreamStatusChangedSubscription } from "@/entities/contents";
import type { ContentStreamStatusChangedSubscriptionType } from "@/types/graphql/site.generated";

// Держим хук локальным для виджета (не в entities/streams — это cabinet-
// паттерн из Task 23): на сайте подписка нужна только здесь, в отличие от
// кабинета, где статус стрима читают и список, и форма.
export function useContentStreamStatusChangedSubscription(id?: string) {
  useSubscription<ContentStreamStatusChangedSubscriptionType>(
    ContentStreamStatusChangedSubscription,
    { variables: { id: id ?? "" }, skip: !id },
  );
}
